import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { StationGroup } from 'src/tmc-yard/client/model/station-group';
import { TmcContextService } from 'src/tmc-common/services/tmc-context.service';
import { TranslationService } from '@sdbn/common';
import { FilterCondition } from '../../../../filter-administration.model';
import { FilterAdministrationContext } from '../../../../filter-administration.context';
import { FilterDetailsComponent } from '../../../../filter-details-component.model';
import { StructureSelectionService } from 'src/tmc-yard/common/structure-selection/structure-selection-dialog/structure-selection-dialog-service';
import { StructureSelection } from 'src/tmc-yard/common/structure-selection/structure-selection.model';

@Component({
  selector: 'app-next-processing-position-editor',
  templateUrl: './next-processing-position-editor.component.html',
  styleUrls: ['./next-processing-position-editor.component.scss']
})
export class NextProcessingPositionEditorComponent implements OnInit, OnDestroy, FilterDetailsComponent {

  stationGroups = new Array<StationGroup>();

  positionName: string;

  tmcContextSubscription: Subscription;

  locations: string[] = [];

  condition: FilterCondition;

  filterAdministrationContext: FilterAdministrationContext;
  filterAdministrationContextSubscription: Subscription;

  constructor(
    public translationService: TranslationService,
    private tmcContextService: TmcContextService,
    private structureSelectionService: StructureSelectionService
  ) {
    this.tmcContextSubscription = this.tmcContextService.updated.subscribe(
      yardConfig => {
        this.stationGroups = this.tmcContextService.getYardConfiguration().stationGroups;
        this.updatePositionName();
      }
    );
  }

  ngOnInit(): void {
  }

  ngOnDestroy() {
    if (this.tmcContextSubscription != null) {
      this.tmcContextSubscription.unsubscribe();
    }

    if (this.filterAdministrationContextSubscription != null) {
      this.filterAdministrationContextSubscription.unsubscribe();
    }
  }

  setFilterAdministrationContext(filterAdministrationContext: FilterAdministrationContext) {
    this.filterAdministrationContext = filterAdministrationContext;
    this.condition = this.filterAdministrationContext.getSelectedFilterCondition();
    this.updatePositionName();
    this.filterAdministrationContextSubscription = this.filterAdministrationContext.contextChange$.subscribe(
      change => {
        try {
          if (change.key === 'selected-filter-condition-changed') {
            this.condition = this.filterAdministrationContext.getSelectedFilterCondition();
            this.updatePositionName();
          }
        } catch (error) {
          console.log(error);
        }
      }
    );
  }

  private updatePositionName() {
    if (this.stationGroups != null && this.condition != null) {
      for (const sg of this.stationGroups) {
        if (this.condition.data.stationGroupExternalKey === sg.externalKey) {
          this.positionName = sg.name;
          return;
        }

        for (const set of sg.stationSets) {

          if (this.condition.data.stationSetExternalKey === set.externalKey) {
            this.positionName = set.name;
            return;
          }

          for (const station of set.stations) {
            if (this.condition.data.stationExternalKey === station.externalKey) {
              this.positionName = station.name;
              return;
            }
          }
        }
      }
    }
  }

  public assignNextProcessingPosition() {

    const structureSelection = new StructureSelection();

    // TODO structureSelectionService erweitern
    // selectStationEvent.includeStations = true;
    // selectStationEvent.includeWaitingareas = false;

    if (this.condition.data.stationGroupExternalKey != null) {
      structureSelection.stationGroupId =
        this.tmcContextService.findStationGroupByExternalKey(this.condition.data.stationGroupExternalKey)?.id;
    } else if (this.condition.data.stationSetExternalKey != null) {
      structureSelection.stationSetId =
        this.tmcContextService.findStationSetByExternalKey(this.condition.data.stationSetExternalKey)?.id;
    } else if (this.condition.data.stationExternalKey != null) {
      structureSelection.stationId = this.tmcContextService.findStationByExternalKey(this.condition.data.stationExternalKey)?.id;
    }

    this.structureSelectionService.selectAny(structureSelection).subscribe(

      value => {

        if (value != null) {
          const selection: StructureSelection = value;
          this.condition.data.stationExternalKey = null;
          this.condition.data.stationSetExternalKey = null;
          this.condition.data.stationGroupExternalKey = null;
          this.positionName = null;

          if (selection.stationId != null) {
            const station = this.tmcContextService.findStationById(selection.stationId);
            this.condition.data.stationExternalKey = station.externalKey;
            this.positionName = station.name;
          } else if (selection.stationSetId != null) {
            const stationSet = this.tmcContextService.findStationSetById(selection.stationSetId);
            this.condition.data.stationSetExternalKey = stationSet.externalKey;
            this.positionName = stationSet.name;
          } else if (selection.stationGroupId != null) {
            const stationGroup = this.tmcContextService.findStationGroupById(selection.stationGroupId);
            this.condition.data.stationGroupExternalKey = stationGroup.externalKey;
            this.positionName = stationGroup.name;
          }
          this.filterAdministrationContext.getFilter().dirty = true;
        }
      }
    );
  }


}
